import { type Writable, writable } from 'svelte/store';

import { type IUploadingFile } from '../models';

export const uploadingFiles: Writable<IUploadingFile[]> = writable([]);
